import axios from "axios";

function getInstance() {
  return axios;
}

export default { getInstance };
